function isTouchDevice() {
  var result = false;
  if (window.ontouchstart === null) {
    result = true;
  }  
  return result;
}
const setVw = function() {
  const vw = document.documentElement.clientWidth / 100;
  const vh = window.innerHeight / 100;
  const lvh = window.outerHeight / 100;
  document.getElementsByTagName('body')[0].style.setProperty('--vw', `${vw}px`);
  document.getElementsByTagName('body')[0].style.setProperty('--vh', `${vh}px`);
  document.getElementsByTagName('body')[0].style.setProperty('--lvh', `${lvh}px`);
}
//Load
$(window).on('load',function(){
  $('body').addClass('isLoaded');
});
//Func
$(function(){
  //Smooth
  $('a[href^="#"]').on('click',function() {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - $('.header').outerHeight() + parseInt($('.headingBlock').css('marginTop'));
    $('body,html').animate({scrollTop:position}, 800);
    if($(this).closest('.header__menuNavList').length && $('.header__btnLink').hasClass('menuOpen')) {
      menuClose();
    }
    return false;
  });
  //Vw
  setVw();
  //Menu
  function menuClose(){
    $('.header__btnLink').removeClass('menuOpen');
    $('.header__menu').stop().slideUp();
  }
  function menuOpen(){
    $('.header__btnLink').addClass('menuOpen');
    $('.header__menu').stop().slideDown();
  }
  $('.header__btnLink').on('click',function(){
    if($(this).hasClass('menuOpen')) {
      menuClose();
    } else {
      menuOpen();
    }
    return false;
  });
});
//LazySizes
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig.customMedia = {
  '--sp': '(max-width: 767px)',
  '--pc': '(min-width: 768px)',
  '--full': '(min-width: 1367px)',
  '--portrait': '(orientation: portrait)',
};
//Scroll
var scrollFlag = '';
function scrollSearch(scrollPosition) {
  var showPosition = 50;
  if(scrollPosition < showPosition && scrollFlag != 'min') {
    scrollFlag = 'min';
    $('body').removeClass('isScroll');
  } else if(scrollPosition >= showPosition && scrollFlag != 'over') {
    scrollFlag = 'over';
    $('body').addClass('isScroll');
  }
}
$(window).on('load scroll',function(){
  var scrollPosition = $(window).scrollTop();
  scrollSearch(scrollPosition);
});
var winW = $(window).width();
$(window).on('resize',function(){
  if(winW != $(window).width()) {
    setVw();
    winW = $(window).width();
  }
});
/* --------------------------------------------------------------------
Product
-------------------------------------------------------------------- */
$('.product__mediaThumbItem').on('click',function(){
  var index = $(this).prevAll('.product__mediaThumbItem').length;
  $(this).closest('.product__media').find('.product__mediaMainItem').hide().eq(index).fadeIn();
});
$('.closeBtn__link').on('click',function(){
  var ref = document.referrer;
  var hereHost = window.location.hostname;
  var sStr = "^https?://" + hereHost;
  var rExp = new RegExp( sStr, "i" );
  if( ref.length == 0 ) {
    location.href = $(this).attr('href');
  }
  else if( ref.match( rExp ) ) {
    history.back();
  }
  else {
    location.href = $(this).attr('href');
  }
  return false;
});
$('.topStory__contentDescBtnLink').on('click',function(){
  $('.topStory__contentDescBtn').toggleClass('isOpen');
  $('.topStory__contentDescText--toggle').stop().slideToggle();
  if($('.topStory__contentDescBtn').hasClass('isOpen')) {
    $('html,body').animate({scrollTop:$('.topStory__contentDescText--toggle').prev('.topStory__contentDescText').offset().top - $('.header').outerHeight()}, 800);
  }
  return false;
});